import { Component, Input, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { AccountResultDto } from 'src/app/dtos/account-result-dto.model';
import { InvoiceDetailsDto } from 'src/app/dtos/invoice-details-dto.model';
import { InvoicePdfEmailInputDto } from 'src/app/dtos/invoice-pdf-email-input-dto.model';
import { Dialog } from 'src/app/helpers/dialog';
import { AccountingService } from 'src/app/services/accounting.service';
import { AccountsReceivableService } from 'src/app/services/accounts-receivable.service';
import { ConfigService } from 'src/app/services/config.service';
import { ModeService } from 'src/app/services/mode.service';
import { OrderService } from 'src/app/services/order.service';
import * as JSZip from 'jszip';
import { PaymentPdfEmailDto } from '../../dtos/payment-pdf-email-dto-model';
import { BillToDto } from '../../dtos/bill-to-dto.model';
import { PaymentPdfDto } from '../../dtos/payment-pdf-dto-model';

@Component({
  selector: 'app-selected-template-email',
  templateUrl: './selected-template-email.component.html',
  styleUrls: ['./selected-template-email.component.css']
})
export class SelectedTeplateEmailComponent implements OnInit {

  private readonly _orderService: OrderService;
  orderIsReadySubscription: Subscription | undefined;
  getSelectedInvoicesSubscription: Subscription | undefined;
  selectedInvoicesList: InvoiceDetailsDto[] = [];
  email = '';
  invoiceIds: number[] = [];
  loading = false;

  visibleTextValue = '';

  emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  disableBillTo = true;
  disableOrderBy = true;
  disableShipTo = true;
  disableSendEmail = false;

  billToContactcheckbox: boolean = false;
  orderByContactcheckbox: boolean = false;
  shipToContactcheckbox: boolean = false;
  accountInfo: AccountResultDto = new AccountResultDto();
  LoggedInUsercheckbox:boolean=false;

  loggedinName:any;
  loggedInUserEmail:any;
  CCrecipientsloggedInUserEmail = '';
  @Input() showTemplateEmailDialog = new Dialog<string>();
  @Input() templateUrl=new Dialog<void>();
  @Input() billToDto = new BillToDto();

  constructor(
    public accountsReceivableService: AccountsReceivableService,
    orderService: OrderService,
    public accountingService: AccountingService,
    public modeService: ModeService,
    public _configService:ConfigService) {
    this._orderService = orderService;
  }

  isNotificationVisible = false;
  notificationVariant: any = '';
  emailNotificationMessage = '';
  isPaymentLedgerEmail = false;
  async ngOnInit(): Promise<void> {
    this.loggedInUserEmail="confirmations@optum.com";
    this.CCrecipientsloggedInUserEmail= this._configService.getLoggedInUserEmail();
    this.loggedinName=this._configService.getLoggedInUserName();
    this.isPaymentLedgerEmail = this.accountsReceivableService.selectedTemplatedValue === 'Payment Ledger';
    if (this.isPaymentLedgerEmail) {
      this.initiatizePaymentReceipt();
    }
    else {
      this.getSelectedInvoicesSubscription = this.accountsReceivableService.getSelectedInvoicesEmitter.
        subscribe((invoices: InvoiceDetailsDto[]) => {
          this.selectedInvoicesList = invoices;
        });
      this.clickSendSelectedToPDF();
    }

  }
  initiatizePaymentReceipt() {
    if (this.billToDto.email !== null && this.billToDto.email !== '') {
      this.billToContactcheckbox = true;
      this.email = this.billToDto.email;
      this.disableBillTo = false;
    }
    else {
      this.disableBillTo = true;
    }

  }
  clickSendSelectedToPDF() {
     if(this.accountsReceivableService.selectedOrder > 0){
       this._orderService.getOrderInformation(this.accountsReceivableService.selectedOrder);
     }
    this.orderIsReadySubscription = this._orderService.orderIsReady.subscribe(() => {
      this.email = '';
      let loggedInUserToIds= this._configService.getLoggedInUserEmail();

      this.accountsReceivableService.getSelectedInvoicesEmitter.
        subscribe((invoices: InvoiceDetailsDto[]) => {
          const distinctOrderByIds = [...new Set(invoices.map(item => item.orderByContactId))];
          const distinctShipToIds = [...new Set(invoices.map(item => item.shipToContactId))];


          if (this.billToDto.email !== null && this.billToDto.email !== '') {
            this.billToContactcheckbox = true;
            this.email = this.billToDto.email;
            this.disableBillTo = false;
          }
          else {
            this.disableBillTo = true;
          }
          this.disableOrderBy = distinctOrderByIds.length > 1 || !this._orderService.orderDto.orderByDto.email;

          this.disableShipTo = distinctShipToIds.length > 1 || !this._orderService.orderDto.shipToDto.email;
        });
    });
  }

  displayNotification(isNotificationVisible: boolean, emailNotificationMessage: string, isSuccess: boolean = false) {
    this.isNotificationVisible = isNotificationVisible;
    this.emailNotificationMessage = emailNotificationMessage;

    if (typeof isSuccess !== 'undefined') {
      this.notificationVariant = isSuccess ? 'success' : 'error';
    }
  }
  changeEmail() {
    const currentUser = JSON.parse(localStorage.getItem('currentUser') as any);
    let emailIds: string[] = [];
    this.email = '';
    let billtoemail = this._orderService.orderDto.billToDto.email==""?this.billToDto.email:this._orderService.orderDto.billToDto.email;
    let loginuseremail = this._configService.getLoggedInUserEmail();
    emailIds.push(this.billToContactcheckbox === true ? billtoemail || '' : '');
    emailIds.push(this.orderByContactcheckbox === true ? this._orderService.orderDto.orderByDto.email || '' : '');
    emailIds.push(this.shipToContactcheckbox === true ? this._orderService.orderDto.shipToDto.email || '' : '');
    emailIds.push(this.LoggedInUsercheckbox==true? loginuseremail||'':'');
    emailIds = [...new Set(emailIds)];
    this.email = emailIds.filter(e => e).join(';');
    this.validateEmailAddress();
  }
  cancelDialog() {
  this.accountsReceivableService.selectedTemplatedValue = "";
  this.templateUrl.close();
  }
  sendEmail(){
    if(this.isPaymentLedgerEmail){
      this.sendPaymentLedger();
    }
    else{
      this.sendPdf();
    }

  }
  sendPdf() {
    const currentUser = JSON.parse(localStorage.getItem('currentUser') as any);
    this.loading = true;
    this.visibleTextValue = 'Sending Email';
    const invoicePdfEmailInputDto = new InvoicePdfEmailInputDto();
    invoicePdfEmailInputDto.emailAddress = this.email;
    invoicePdfEmailInputDto.ccRecipients=this.CCrecipientsloggedInUserEmail;
    invoicePdfEmailInputDto.subject = this.accountsReceivableService.EmailSubject;
    invoicePdfEmailInputDto.body = this.accountsReceivableService.EmailBody;
   
    invoicePdfEmailInputDto.LoggedInUserEmail="confirmations@optum.com";

    this.selectedInvoicesList.forEach(item => {
      invoicePdfEmailInputDto.invoiceIds.push(Number(item.invoiceNumber));
    });
    const waitListMessage = "Sending PDF";
    this.modeService.addToWaitList(waitListMessage);
    console.log(invoicePdfEmailInputDto,"invoicePdfEmailInputDtoinvoicePdfEmailInputDto");
    this.accountingService.emailInvoicePdfs(invoicePdfEmailInputDto)
      .subscribe(() => {
        this.modeService.removeFromWaitList(waitListMessage);
        this.displayNotification(true, 'Mail sent successfully', true);
        this.selectedInvoicesList = [];
        setTimeout(() => {
          this.displayNotification(false, '');
          this.cancelDialog();
        }, 2000);
      }, error => {
        this.modeService.removeFromWaitList(waitListMessage);
        console.log(error);

        setTimeout(() => {
          this.displayNotification(true, 'An error occurred while sending an email', false);
        }, 2000);
      });
  }

  async sendPaymentLedger() {
    const currentUser = JSON.parse(localStorage.getItem('currentUser') as any);
    this.loading = true;
    this.visibleTextValue = 'Sending Email';
    const paymentPdfEmailDto = new PaymentPdfEmailDto();
    paymentPdfEmailDto.accountId = this.billToDto.id;
    paymentPdfEmailDto.emailRecipients = this.email;
    paymentPdfEmailDto.subject = this.accountsReceivableService.EmailSubject;
    paymentPdfEmailDto.emailBody = this.accountsReceivableService.EmailBody;
    paymentPdfEmailDto.loggedInUserEmail = this._configService.getLoggedInUserEmail();
    paymentPdfEmailDto.dateSeleccionRange=this.accountsReceivableService.paymentPdfEmailDto.dateSeleccionRange;
    paymentPdfEmailDto.startDate=this.accountsReceivableService.paymentPdfEmailDto.startDate;
    paymentPdfEmailDto.endDate=this.accountsReceivableService.paymentPdfEmailDto.endDate;
    const waitListMessage = "Sending Payment Ledger email";
    this.modeService.addToWaitList(waitListMessage);

    this.accountingService.emailPaymentLedger(paymentPdfEmailDto)
      .subscribe(() => {
        this.modeService.removeFromWaitList(waitListMessage);
        this.displayNotification(true, 'Mail sent successfully', true);
        setTimeout(() => {
          this.displayNotification(false, '');
          this.cancelDialog();
        }, 2000);
      }, error => {
        this.modeService.removeFromWaitList(waitListMessage);
        console.log(error);

        setTimeout(() => {
          this.displayNotification(true, 'An error occurred while sending payment ledger email', false);
        }, 2000);
      });
  }
  downloadPaymentLedger() {
    const paymentPdfDto = new PaymentPdfDto();
    paymentPdfDto.accountId = this.billToDto.id;
    paymentPdfDto.startDate=this.accountsReceivableService.paymentPdfEmailDto.startDate;
    paymentPdfDto.endDate=this.accountsReceivableService.paymentPdfEmailDto.endDate;
    paymentPdfDto.dateSeleccionRange=this.accountsReceivableService.paymentPdfEmailDto.dateSeleccionRange;

    this.accountingService.downloadPaymentLedger(paymentPdfDto).subscribe(async (blob: Blob) => {
     const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `PaymentLedger-${paymentPdfDto.accountId}.pdf`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
    });
  }
  onEmailBodyChange(event: any){
    this.accountsReceivableService.EmailBody = event.target.innerHTML;
  }
  handleLinkClick(event: any){
    if(event.target.tagName === 'A'){
      event.preventDefault();
      window.open(event.target.href, '_blank');
    }
  }
  onChangeTemplate(event: any){
  this.showTemplateEmailDialog.close('openTemplateDialog');
}

  downloadInvoicePdf() {
    this.invoiceIds = [];
    this.selectedInvoicesList.forEach(item => {
      this.invoiceIds.push(Number(item.invoiceNumber));
    });
    this.accountingService.downloadInvoicesPDF(this.invoiceIds).subscribe(async (blob: Blob) => {
      // If single invoice, download directly as PDF
      if (this.invoiceIds.length === 1) {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `Invoice_${this.invoiceIds[0]}.pdf`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      } else {
        // Multiple invoices - unzip and download each file separately
        try {
          const zip = await JSZip.loadAsync(blob);

          // Iterate through each file in the zip
          const filePromises: Promise<void>[] = [];
          zip.forEach((relativePath: string, zipEntry: JSZip.JSZipObject) => {
            const promise = zipEntry.async('blob').then((fileBlob: Blob) => {
              const url = window.URL.createObjectURL(fileBlob);
              const a = document.createElement('a');
              a.href = url;
              a.download = relativePath; 
              document.body.appendChild(a);
              a.click();
              document.body.removeChild(a);
              window.URL.revokeObjectURL(url);
            });
            filePromises.push(promise);
          });

          // Wait for all files to be downloaded
          await Promise.all(filePromises);
        } catch (error) {
          console.error('Error unzipping files:', error);
          // Fallback: download the zip file as-is
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = 'Invoices.zip';
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);
        }
      }
    });
  }
  validateEmailAddress() {
    if ( this.email === '' && this.CCrecipientsloggedInUserEmail === '') {
      this.disableSendEmail = true;
      return;
    }

    let emailList = this.email?.split(";");
     emailList = emailList.concat(this.CCrecipientsloggedInUserEmail?.split(";"))?.map(e => e.trim());
    if(emailList.every(element => !new RegExp(this.emailPattern).test(element))){
      this.disableSendEmail = true;
    }
    else{
      this.disableSendEmail = false;
    }
  }
  downloadPdf(){
    if(this.isPaymentLedgerEmail){
      this.downloadPaymentLedger();
    }
    else{
      this.downloadInvoicePdf();
    }
  }
}
